export default "__VITE_ASSET__6c56f346__"